import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { MailCenterService } from '../mail-center/mail-center.service';

@Component({
  selector: 'app-bbf',
  templateUrl: './bbf.component.html',
  styleUrls: ['./bbf.component.css']
})
export class BbfComponent implements OnInit {
message="";
url: any; //Angular 11, for stricter type
msg = "";
showBBF=true;
countryDecision=false;
showHakTalebiKarar=false;

	//selectFile(event) { //Angular 8
	selectFile(event: any) { //Angular 11, for stricter type
		if(!event.target.files[0] || event.target.files[0].length == 0) {
			this.msg = 'You must select an image';
			return;
		}

		var mimeType = event.target.files[0].type;

		if (mimeType.match(/image\/*/) == null) {
			this.msg = "Only images are supported";
			return;
		}

		var reader = new FileReader();
		reader.readAsDataURL(event.target.files[0]);

		reader.onload = (_event) => {
			this.msg = "";
			this.url = reader.result;
		}
	}

  constructor(private mailService:MailCenterService) { }

  ngOnInit(): void {
  }
  sendMail() {
    const time=(Math.round((Date.now()/1000)+300)); //300 for delay
    this.mailService.sendStatusUpdate("name1", "this.inventionName", "this.status", "share","utuzer@sisecam.com",time).pipe(first())
  .subscribe(resp => {
    //console.log({ resp });
    this.message="e-posta gönderilmiştir";
    alert("e-posta gönderilmiştir")
  }, err => {
    console.error({ err });

  });
}
visibleBBF () {this.showBBF=true;
              this.showHakTalebiKarar=false;
              this.countryDecision=false;}
              visibleHak () {this.showBBF=false;
                this.showHakTalebiKarar=true;
                this.countryDecision=false;}
                visibleUlke () {this.showBBF=false;
                  this.showHakTalebiKarar=false;
                  this.countryDecision=true;}
onToggle(){this.showBBF=false;
            this.showHakTalebiKarar=false;
            this.countryDecision=false}


}
